// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"menu-item_2za-kB","menuItem":"menu-item_2za-kB","txt":"txt_3OuowB","tag":"tag_38g9kX","block-warn":"block-warn_s641ox","blockWarn":"block-warn_s641ox"};